import httpClient from '../httpClient';
import type { ReportSchedule, CreateSchedulePayload, UpdateSchedulePayload, AIScheduleParseResult } from '@/types/reportScheduler';

const BASE_URL = '/admin/reports/schedules';

// Normalize MySQL tinyint(1) to boolean and parse JSON fields
const normalizeSchedule = (s: any): ReportSchedule => ({
  ...s,
  is_active: !!s.is_active,
  recipients: Array.isArray(s.recipients) ? s.recipients : JSON.parse(s.recipients || '[]'),
  days_of_week: Array.isArray(s.days_of_week) ? s.days_of_week : (s.days_of_week ? JSON.parse(s.days_of_week) : null),
  days_of_month: Array.isArray(s.days_of_month) ? s.days_of_month : (s.days_of_month ? JSON.parse(s.days_of_month) : null),
  specific_dates: Array.isArray(s.specific_dates) ? s.specific_dates : (s.specific_dates ? JSON.parse(s.specific_dates) : null),
});

export const getSchedules = async (): Promise<{ success: boolean; data: ReportSchedule[] }> => {
  const response = await httpClient.get(BASE_URL);
  const body = response.data as any;

  let items: any[] = [];
  if (Array.isArray(body?.data)) {
    items = body.data;
  } else if (Array.isArray(body)) {
    items = body;
  } else if (body?.data?.data && Array.isArray(body.data.data)) {
    items = body.data.data;
  }

  return {
    success: true,
    data: items.map(normalizeSchedule),
  };
};

export const createSchedule = async (data: CreateSchedulePayload): Promise<{ success: boolean; data: ReportSchedule }> => {
  const response = await httpClient.post(BASE_URL, data);
  return response.data;
};

export const updateSchedule = async (id: number, data: UpdateSchedulePayload): Promise<{ success: boolean; data: ReportSchedule }> => {
  const response = await httpClient.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deleteSchedule = async (id: number): Promise<{ success: boolean }> => {
  const response = await httpClient.delete(`${BASE_URL}/${id}`);
  return response.data;
};

export const toggleSchedule = async (id: number, isActive: boolean): Promise<{ success: boolean; data: ReportSchedule }> => {
  const response = await httpClient.patch(`${BASE_URL}/${id}/toggle`, { isActive });
  return response.data;
};

export const aiParseSchedule = async (command: string): Promise<AIScheduleParseResult> => {
  const response = await httpClient.post(`${BASE_URL}/ai-parse`, { command });
  const body = response.data as any;
  return body?.data || body;
};
